/* Publish by EComposer at 2026-09-27 12:11:21*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ye8osm9k89h"]=  window.__ectimmers["ecom-ye8osm9k89h"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ye8osm9k89h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ye8osm9k89h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-behp77uqq0h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-behp77uqq0h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kd0n45aql1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kd0n45aql1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n148megb0ai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n148megb0ai', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kn2itoofthq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kn2itoofthq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nwx2ln0g3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nwx2ln0g3o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kiip6ovx8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kiip6ovx8i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5n49mww13v6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5n49mww13v6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h38gqesobhr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h38gqesobhr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ln3nqfrl37').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ln3nqfrl37', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ursevqd4kyi"]=  window.__ectimmers["ecom-ursevqd4kyi"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-ursevqd4kyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ursevqd4kyi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfga3wi7ico').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfga3wi7ico', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-czbjps77tup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-czbjps77tup', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hunqbsu4wm4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hunqbsu4wm4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iq318b0qjln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iq318b0qjln', settings: {"link":"lightbox"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}